import { getRegisterInterests, shopLists } from '@/api/userCommon'
import { reactive, ref } from "vue";
import { cookie } from "@u/common";

export const useRegisterInterestsInfo  = async () => {

    // const list = {
    //   'US': { firstRegister: '$200', largeOrder: '$2000', firstUrl: '/', secondUrl: `${import.meta.env.VITE_MY_URL}/index`, thirdUrl: COLLECTION_LINK[CR] },
    //   'GB': { firstRegister: '￡150', largeOrder: '￡1500', firstUrl: '/', secondUrl: `${import.meta.env.VITE_MY_URL}/index`, thirdUrl: COLLECTION_LINK[CR] },
    //   'CA': { firstRegister: '$200', largeOrder: '$2000', firstUrl: '/', secondUrl: `${import.meta.env.VITE_MY_URL}/index`, thirdUrl: COLLECTION_LINK[CR] },
    //   'AU': { firstRegister: 'AUD150', largeOrder: '', firstUrl: '/', secondUrl: `${import.meta.env.VITE_MY_URL}/index` },
    //   'DE': { firstRegister: '200€', largeOrder: '2.000€', firstUrl: '/', secondUrl: `${import.meta.env.VITE_MY_URL}/index`, thirdUrl: COLLECTION_LINK[CR]},
    //   'FR': { firstRegister: '150€', largeOrder: '1500€', firstUrl: '/', secondUrl: `${import.meta.env.VITE_MY_URL}/index`, thirdUrl: COLLECTION_LINK[CR]},
    //   'IT': { firstRegister: '150€', largeOrder: '1500€',firstUrl: '/',  secondUrl: `${import.meta.env.VITE_MY_URL}/index`, thirdUrl: COLLECTION_LINK[CR]},
    //   'ES': { firstRegister: '150€', largeOrder: '1500€', firstUrl: '/', secondUrl: `${import.meta.env.VITE_MY_URL}/index`, thirdUrl: COLLECTION_LINK[CR]},
    //   'JP': { firstRegister: '2000円', largeOrder: '', firstUrl: '/', secondUrl: `/account/order`, thirdUrl: 'https://helpcenter.jackery.com/hc/ja/requests/new' },
    //   'EU': { firstRegister: '150€', largeOrder: '2000€', firstUrl: '/', secondUrl: `${import.meta.env.VITE_MY_URL}/index`, thirdUrl: COLLECTION_LINK[CR] },
    // }

    const list = {
        'US': { firstRegister: '$200', largeOrder: '$15' },
        'GB': { firstRegister: '￡150', largeOrder: '￡1500' },
        'CA': { firstRegister: '$200', largeOrder: '$2000' },
        'AU': { firstRegister: 'AUD150', largeOrder: '' },
        'DE': { firstRegister: '200€', largeOrder: '2.000€' },
        'FR': { firstRegister: '150€', largeOrder: '1500€' },
        'IT': { firstRegister: '150€', largeOrder: '1500€' },
        'ES': { firstRegister: '150€', largeOrder: '1500€' },
        'JP': { firstRegister: '2000円', largeOrder: '' },
        'EU': { firstRegister: '150€', largeOrder: '2000€' },
    }
    const CR = cookie.get("_jk_cr") || localStorage.getItem('JACKERY_ID_CR') || 'US'
    const shopId = cookie.get('_jk_shop_id') || localStorage.getItem("JACKERY_ID_SHOP_ID");
    const getShopId = async () => {
        const { current: { shop_id, }, } = await shopLists()
        return shop_id
    }
    // 设置默认金额
    const firstRegisterRel = ref(list[CR].firstRegister) // 首次注册
    const largeOrderRel = ref(list[CR].largeOrder) // 大额订单
    const getDefaultValue = async () => {
        try {
            if (!shopId) {
                const shop_id = await getShopId()
                const { firstRegister = '', largeOrder = '' } = await getRegisterInterests({ shopId: shop_id, })
                // 这里可以加一个接口请求,请求后台数据,得到面额
                firstRegisterRel.value = firstRegister || list[CR].firstRegister
                largeOrderRel.value = largeOrder || list[CR].largeOrder || ''
            } else {
                const { firstRegister = '', largeOrder = '' } = await getRegisterInterests({ shopId, })
                // 这里可以加一个接口请求,请求后台数据,得到面额
                firstRegisterRel.value = firstRegister || list[CR].firstRegister
                largeOrderRel.value = largeOrder || list[CR].largeOrder || ''
            }
        } catch {
            firstRegisterRel.value = list[CR].firstRegister
            largeOrderRel.value = list[CR].largeOrder || ''
        }
    }
    await getDefaultValue()
    return {
        firstRegister: firstRegisterRel.value,
        largeOrder: CR === 'US' ? list[CR].largeOrder : largeOrderRel.value
    }
}
